import { gsap } from 'gsap';
import Splide from '@splidejs/splide';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { InitMap } from '../misc/InitMap';
import { PageHandler } from './PageHandler';
import imagesLoaded from 'imagesloaded';
import jQuery from 'jquery';
import { Utils } from '../misc/Utils';

export class ContactPageHandler extends PageHandler {
    constructor(id) {
    	super(id);
    }

    init() {
	
		
    }

    ajax() {
	
	}

    destroy() {
    
    }

	events() {
		
	}

	transitions() {
		// gsap.fromTo('.contact .intro', {backgroundSize: "600%"}, {backgroundSize: "100%", duration: 0.5, ease: 'power2.inout'});
		Utils.fadeInUp('.contact .section-content')
	}
}